// 專欄列表
"use client";

import { useState } from "react";
import { getColumnListByPage } from "@/app/actions";
import ColumnListComponent from "../basic/ColumnListComponent"; // 專欄列表元件
import LoadMore from "../index/LoadMore"; // 載入更多

const ColumnPageList = ({ initialColumnList, locale, pageCnt }) => {
  const [columnList, setColumnList] = useState(initialColumnList); // 專欄列表
  const [pageIndex, setPageIndex] = useState(1); // 頁碼
  const [loadingMore, setLoadingMore] = useState(false);

  // 依分頁取得列表
  const getColumnList = async () => {
    try {
      setLoadingMore(true);
      const { records } = await getColumnListByPage(locale, pageIndex, 9);

      if (records) {
        setColumnList((prev) => [...prev, ...records]);
        setPageIndex((prev) => prev + 1);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoadingMore(false);
      }, 300);
    }
  };

  return (
    <>
      {/* 列表 */}
      <section
        className="flex gap-x-[20px] gap-y-[30px] flex-wrap [&>*]:w-[calc((100%-40px)/3)]
      ulb:[&>*]:w-[calc((100%-30px)/2)] umd:[&>*]:!w-full usm:gap-y-[25px]"
      >
        {columnList?.map((column, i) => (
          <ColumnListComponent
            key={i + "column-list"}
            column={column}
            location="column"
          />
        ))}
      </section>

      {/* 載入更多 */}
      {pageCnt > pageIndex && (
        <LoadMore loadingMore={loadingMore} onLoad={getColumnList} />
      )}
    </>
  );
};

export default ColumnPageList;
